import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { v4 as uuidv4 } from 'uuid';

const SESSION_ID_KEY = 'referral_session_id';

export const useReferralTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const trackReferral = async () => {
      try {
        // Only track referrals from /r/ path
        if (location.pathname.startsWith('/r/')) {
          // Extract referral code (everything after /r/)
          const referralCode = location.pathname.substring(3);
          
          // Only track if there's a valid referral code
          if (referralCode && !referralCode.includes('/')) {
            // Get or create session ID
            let sessionId = sessionStorage.getItem(SESSION_ID_KEY);
            if (!sessionId) {
              sessionId = uuidv4();
              sessionStorage.setItem(SESSION_ID_KEY, sessionId);
            }

            // Track referral using the safe tracking function
            await supabase.rpc('track_referral', {
              p_code: referralCode,
              p_session_id: sessionId,
              p_path: location.pathname,
              p_query_params: location.search || null,
              p_user_agent: navigator.userAgent,
              p_referrer: document.referrer || null
            });

            // Store referral code for attribution
            localStorage.setItem('referral_code', referralCode);
          }
        }
      } catch (error) {
        // Silently handle errors to not disrupt user experience
        console.error('Error tracking referral:', error);
      }
    };

    trackReferral();
  }, [location.pathname, location.search]);
};